import type { ResponseData } from './types';

export const MOCK_DATA: ResponseData = [
    { quote: 243, quotesDate: '2023-01' },
    { quote: 431, quotesDate: '2023-02' },
    { quote: 143, quotesDate: '2023-03' },
    { quote: 555, quotesDate: '2023-04' },
    { quote: 694, quotesDate: '2023-09' },
];

export const MIN_DATE = new Date('2025-01-01');
export const MAX_DATE = new Date('2025-12-01');
